import {useEffect, useState} from 'react'
import {BooksitoutServer} from '../../../config/BooksitoutServer'
import {BookRecommenderResponse} from './BookRecommenderResponse'
import BookIsbnResponse from "../../book/isbn/BookIsbnResponse";

export interface RecommendationSource {
    url: string
    imageUrl: string | null
}

export interface Recommendation {
    name: string | null
    source: RecommendationSource | null
    date: string | null
    books: BookIsbnResponse[]
}

export interface BookRecommendationsResponse {
    recommender: BookRecommenderResponse
    recommendersBooks: BookIsbnResponse[]
    recommendations: Recommendation[]
}

const useBookRecommenderDetail = (recommenderId: string | null) => {
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const [data, setData] = useState<BookRecommendationsResponse | null>(null)

    useEffect(() => {
        setIsLoading(true)

        if (recommenderId) {
            BooksitoutServer
                .get(`/v1/book-recommenders/${recommenderId}`)
                .then((res) => setData(res.data))
                .catch(() => setIsError(true))
                .finally(() => setIsLoading(false))
        } else {
            setIsError(true)
            setIsLoading(false)
        }
    }, [recommenderId])

    return [data, isLoading, isError] as const
}

export default useBookRecommenderDetail